export { default as Field } from './Field.vue'
export const Icon = 'data_usage'
